import { Controller } from "@hotwired/stimulus";

const FIELDS_BY_TYPE = {
  discount_percentage: ["percentage"],
  discount_fixed: ["amount"],
  free_item: ["item"],
  free_service: ["item"],
  free_delivery: [],
};

export default class extends Controller {
  static targets = ["type", "percentage", "amount", "item"];
  static values = { type: String };

  connect() {
    this.sync(this.typeValue);
  }

  typeChanged() {
    this.sync(this.typeTarget.value);
  }

  sync(type) {
    const visible = FIELDS_BY_TYPE[type] || [];
    ["percentage", "amount", "item"].forEach((name) => {
      const target = this[`${name}Target`];
      if (!target) return;
      target.classList.toggle("hidden", !visible.includes(name));
    });
  }
}
